import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import axios from 'axios';
import AppSheetTableGrid from '../../AppSheetTableGrid';

const AppSheetTableWidget = ({ widget }) => {
  const tableId = widget?.params?.tableId ?? null;
  const tableName = widget?.params?.tableName ?? null;
  const [table, setTable] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const lookupKey = useMemo(() => `${tableId || ''}:${tableName || ''}`, [tableId, tableName]);

  useEffect(() => {
    let active = true;
    const loadTables = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await axios.get('/api/appsheet/tables');
        if (!active) return;
        const tables = Array.isArray(data?.tables) ? data.tables : [];
        const matched = tableId != null
          ? tables.find((entry) => String(entry.id) === String(tableId))
          : tableName
          ? tables.find((entry) => entry.name === tableName)
          : null;
        if (!matched) {
          setError('AppSheet table not found.');
          setTable(null);
          return;
        }
        setTable(matched);
      } catch (err) {
        if (!active) return;
        setError(err?.response?.data?.error || err?.message || 'Failed to load AppSheet table.');
        setTable(null);
      } finally {
        if (active) setLoading(false);
      }
    };
    void loadTables();
    return () => {
      active = false;
    };
  }, [lookupKey, tableId, tableName]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="warning">{error}</Alert>;
  }

  return <AppSheetTableGrid table={table} />;
};

export default AppSheetTableWidget;
